import {useAjouterAuPanier} from '@/hooks/livraison/use-ajouter-au-panier';
import {TFunction} from 'i18next';
import {BuyButton} from './BuyButton';
import {
  ContextsComposant,
  ItemCatalogue2FF,
  getAddArticlePayloadWithColisFallback,
  useLivraisonsPossiblesContext,
} from 'ff-common';
import {useSimpleTextToast} from '@/hooks/useSimpleTextToast';

export const AjouterButton: React.FC<{
  itemCatalogue: ItemCatalogue2FF;
  commandeEnColis: boolean;
  context: ContextsComposant;
  t: TFunction;
  texte?: string;
  onProductClick?: (code_article: string) => void;
  panier_id?: string; // ID du panier cible (notamment pour les paniers PDF)
  somethingSubmitting?: boolean;
}> = ({
  itemCatalogue,
  commandeEnColis,
  texte,
  t,
  onProductClick,
  panier_id,
  somethingSubmitting = false,
}) => {
  // console.log('RERENDER : AjouterButton '+ itemCatalogue.tolede.code_article);

  const textToast = useSimpleTextToast();
  const {livraisonSelectionnee} = useLivraisonsPossiblesContext();
  const ajouterAuPanier = useAjouterAuPanier(
    livraisonSelectionnee.data.id,
    textToast,
    onProductClick,
  );
  const {
    submit: ajouterAuPanierAction,
    isSubmitting: ajouterAuPanierSubmitting,
  } = ajouterAuPanier;

  const onClick = () => {
    const codeArticle = itemCatalogue.code;
    const quantiteColisEntier = itemCatalogue.quantite_colis_entier;
    const minimumCommande = itemCatalogue.minimum_de_commande_client;
    const multipleCommande = itemCatalogue.multiple_de_commande_client;
    ajouterAuPanierAction({
      code_article: codeArticle,
      ...getAddArticlePayloadWithColisFallback({
        commandeEnColis,
        quantiteColisEntier,
        minimumCommande,
        multipleCommande,
      }),
      panier_id, // Passer le panier_id pour forcer l'ajout au panier spécifique
    });
  };

  return (
    <BuyButton
      libelle={texte ?? t('bouton_achat.buy')}
      onClick={onClick}
      isSubmitting={ajouterAuPanierSubmitting || somethingSubmitting}
    />
  );
};
